export default "__VITE_ASSET__qs_q3gIW__"